export default {
      id: "location-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#location-usage",
      toString: function () {
        return this.url;
      }
    }